// extracted by mini-css-extract-plugin
export default {"link":"Nq7ZYT","container":"weo8mW","title":"AeOs8r","description":"s_fIAY","arrow":"SjZPrY"};